<template>
  <b-modal
    id="modal-cancel-pesanan"
    title="Batalkan Pesanan"
    :visible="open"
    :ok-disabled="!reason || peding"
    :cancel-disabled="peding"
    ok-title="Batalkan"
    @hidden="onHidden"
    @shown="onShown"
    @ok="onSubmit"
  >
    <b-alert
      v-if="data.status === 'confirmed'"
      variant="danger"
      show
      class="d-flex"
    >
      <feather-icon
        class="mr-25"
        size="20"
        icon="InfoIcon"
      />
      <div class="ml-25">
        Membatalkan pesanan yang belum dibayar juga akan membatalkan pembayaran.
      </div>
    </b-alert>
    <b-card-text>
      Apakah anda yakin untuk membatalkan pesanan?
    </b-card-text>
    <b-form-textarea
      v-model="reason"
      placeholder="Alasan pembatalan*"
    />
    <div v-if="data.status === 'accepted' && canAccess('manage', 'MerchantV2')">
      <b-form-checkbox
        v-model="emptyStock"
        class="mt-1"
        switch
      >
        Ubah stok produk jadi kosong
      </b-form-checkbox>

      <div
        v-if="emptyStock && data.items && data.items.length > 1"
        class="mt-1 border rounded p-1"
        style="max-height: 300px; overflow-y: auto;"
      >
        <div
          v-for="(item, index) in data.items"
          :key="index"
          class="d-flex align-items-start"
          :class="{'mb-1 pb-1 border-bottom': index < data.items.length - 1}"
        >
          <b-form-checkbox
            v-model="selectedItems"
            :value="item.id"
          />
          <b-img
            v-if="item.product && item.product.images && item.product.images.length"
            rounded
            width="50"
            height="50"
            :src="linkStaging(item.product.images[0].image_url)"
            :alt="item.product.name"
            class="mr-1"
            style="object-fit: cover"
            @error="(event) => {
              event.target.src = require('@/assets/images/icons/broken-image.svg')
            }"
          />

          <div class="flex-grow-1">
            <div
              class="font-weight-bold"
              style="max-width: 300px; display: -webkit-box; -webkit-line-clamp: 2; line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;"
              :title="item.product.name"
            >
              {{ item.product.name }}
            </div>
            <div
              v-if="item.attribute_concat"
              class="small text-muted"
            >
              {{ item.attribute_concat }}
            </div>
            <div class="d-flex justify-content-between small mt-50">
              <span>SKU: {{ item.sku_name || '-' }}</span>
              <!-- <span class="font-weight-bold">Qty: {{ item.qty }}</span> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import {
  BCardText,
  BAlert,
  BFormTextarea,
  BFormCheckbox,
  BImg,
} from 'bootstrap-vue'
import { mapActions } from 'vuex'

export default {
  components: {
    BCardText,
    BAlert,
    BFormTextarea,
    BFormCheckbox,
    BImg,
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    hide: {
      type: Function,
      default: null,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      resi: '',
      peding: false,
      reason: '',
      emptyStock: false,
      selectedItems: [],
    }
  },
  methods: {
    ...mapActions('transaction', ['onCancelOrder']),
    onHidden() {
      this.hide()

      this.name = ''
    },
    onShown() {},
    async onSubmit() {
      this.peding = true
      const payload = {
        idTransaction: this.data.id,
        reason: this.reason,
      }

      if (this.emptyStock && this.selectedItems.length) {
        payload.empty_stock_sku_ids = this.selectedItems
      }

      await this.onCancelOrder(payload)
      this.peding = false
      await this.$emit('callback')
      this.onHidden()
    },
  },
  watch: {
    emptyStock(newValue) {
      if (newValue && this.data.items) {
        if (this.data.items.length === 1) {
          this.selectedItems = this.data.items.map(item => item.id)
        } else {
          this.selectedItems = []
        }
      } else {
        this.selectedItems = []
      }
    },
  },
}
</script>
